module.exports = __webpack_public_path__ + "static/media/mpds_505-illustration.7e6dec4a.svg";